import { environment } from '../environments/environment';

export const servers = {
  cloud: environment.envVar.API_BASE_URL,
  localhost: 'http://localhost:4001'
};
